import Vue from 'vue'
import RtvFooter from './components/RtvFooter'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

new Vue({
  el: '#app-rtv',
  components: {
    RtvFooter
  }
})



// WEBPACK FOOTER //
// ./src/main.js